import { getSearchedAndPromotedItems } from '@/redux/modules/search/aggregateResults/searchAggregate.selectors';
import { getSimilarItemIds } from '@/redux/modules/similarItems';
import { useAppSelector } from '@/redux/hooks';
import useGetSearchColumns from '@/hooks/useGetSearchColumns';

export const useSimilarActiveItems = () => {
    const columns = useGetSearchColumns({ isOnSearchPage: true });

    const searchPageItemIds = useAppSelector((state) => getSearchedAndPromotedItems(state, columns));

    const firstItemId = searchPageItemIds[0];

    const similarActiveItemIds = useAppSelector((state) => (firstItemId ? getSimilarItemIds(state, firstItemId) : []));
    return similarActiveItemIds;
};
